import baseAPI from '@/http'

const router = 'api/calendario/encontro'

export const meetingAPI = {
  create: (meeting) => baseAPI.post(router, meeting),
  update: (meeting) => baseAPI.put(router, meeting),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getName: (meeting) => baseAPI.post(router + '/obter-nome', meeting),
  getByCity: (id) => baseAPI.get(`${router}` + '/get-by-municipio' + `/${id}`),
  getByCitySemRelatorio: (id) => baseAPI.get(`${router}` + '/get-by-municipio-sem-relatorio' + `/${id}`),
  getNames: (meetings) => baseAPI.post(router + '/obter-nomes', meetings),
  createInBatch: (meetings) => baseAPI.post(router + '/store-in-batch', meetings),
  getByFilter: (filter) => baseAPI.post(router + '/get-by-filtro', filter),
  getMeetingByFilter: (filter) => baseAPI.post(router + '/get-encontro-by-filtro', filter)
}
